import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AuthService } from '../auth/auth.service';
import { KanbanService } from './kanban.service';
import { environment } from '../../environments/environment';
import { decodeBase64ToText, encodeToBase64, formatDate } from '../utility';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../api.service';
import { HomeService } from '../home/home.service';
import { Subscription } from 'rxjs';
import { PageMetadataService } from '../shared/services/page-metadata.service';
import { HttpService } from '../shared/services/http.service';
import { HelperService } from '../shared/services/helper.service';
import { SidebarService } from '../shared/services/sidebar.service';
import { WizardService } from '../shared/quick-action/wizard/wizard.service';

@Component({
  selector: 'app-kanban-dashboard',
  templateUrl: './kanban-dashboard.component.html',
  styleUrl: './kanban-dashboard.component.css',
})
export class KanbanDashboardComponent implements OnInit {
  env = environment;
  ref: DynamicDialogRef | undefined;
  breadCrumbItems: MenuItem[] | undefined;
  breadCrumbHome: MenuItem | undefined;
  helper = inject(HelperService);
  // toggle button
  stateOptions: any[] = [
    { label: 'STO', value: 'quarterly' },
    { label: 'MTO', value: 'annual' },
  ];
  value: string = 'quarterly';
  kanbanCard = [];
  kanbanCardData = [];
  category: string;
  quarter: any[];
  selQuater: string = '';
  selGroups: any;
  selectedGroup: any = {};
  selectMember: any
  kanbanPayload: any = {
    outcome_type: 'quarterly',
    outcome_status: '',
  };
  outcome_typeData: any = '';
  //currentQuater:any;

  private kanbanService = inject(KanbanService);
  private roleSubscription: Subscription;
  private quaterSubscription: Subscription;
  private apiService = inject(ApiService);
  private homeService = inject(HomeService);
  private httpService = inject(HttpService);
  private wizardService = inject(WizardService);

  currentYear: any;

  notstarted: any = [];
  ongoing: any = [];
  completed: any = [];
  delayed: any = [];
  terminated: any = [];
  isKanbanBoardDataLoaded: boolean = true;
  currentQuater: any;
  notStartedCount: any;
  ongoingCount: any;
  completedCount: any;
  delayedCount: any;
  terminatedCount: any;
  activePeriod: any;
  outcomeYear: { key: number; value: number }[];
  outcome_year: any;
  groupFilter: any = [];
  members: any = [];

  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    public sidebarService: SidebarService,
    private pageMetaData: PageMetadataService
  ) {}

  ngOnInit(): void {
    this.pageMetaData.setTitle('Kanban | OBP');
    this.outcomeYear = this.helper.generateYearArray(2022);
   
    if (this.sidebarService.selectedKanbanDashboardYear == null) {
      this.sidebarService.selectedKanbanDashboardYear = {
        key: new Date().getFullYear(),
        value: new Date().getFullYear(),
      };
      this.outcome_year = new Date().getFullYear();
    }
    this.breadCrumbItems = [{ label: 'Kanban View' }];

    this.breadCrumbHome = { label: 'Home', routerLink: '/home' };

    this.roleSubscription = this.apiService.role$.subscribe((data) => {
      this.category = data;
      this.fetchCurrentYear(data);
        this.getGroupList('', true, true);
    });


    if (this.category != 'affiliate') {
      this.quaterSubscription = this.apiService.quarter$.subscribe((data) => {
        this.selQuater = data;
      });
    } else {
      this.value = 'annual';
    }

    
   
  }

  fetchCurrentYear(cat: any) {
    this.httpService
      .post(`${environment.opbBackendHost}/api/member/current/year`, {})
      .subscribe((res: any) => {
        this.currentYear = res?.data;
        this.quarterList(cat);
      });
  }

  onKanbanDashboardYearChange(event: any) {
    this.sidebarService.selectedChartProgressDashboardYear = event?.value;
    this.outcome_year = event?.value?.value;
    this.kanbanPayload.outcome_year = event?.value?.value || event?.value;
    this.getQuarterListByYear(
      this.category,
      event?.value?.value || event?.value
    );
    this.getAllKanbanList();
  }

  getQuarterListByYear(cat: any, year: any) {
    this.helper
      .fetchquarterListBasedOnYear(cat, year)
      .subscribe((data: any) => {
        try {
          const parsedData = data;
          this.quarter = parsedData.data || [];
          this.quarterFields(this.quarter);
        } catch (error) {
          console.error('Error parsing decoded data:', error);
        }
      });
  }

  clearMember(){
    this.selectMember=null
  }

  quarterList(cat: string) {
    const data = {
      year: this.currentQuater,
    };
    this.homeService.getQuarterList(data, cat).subscribe(
      (data: any) => {
        try {
          const parsedData = data;
          this.quarter = parsedData.data || [];
          this.quarterFields(this.quarter);
        } catch (error) {
          console.error('Error parsing decoded data:', error);
        }
      },
      (error) => {
        console.error('Error fetching users', error);
      }
    );
  }

  async kanbanList(cat: string, outcome_type?: string, outcome_status?: any) {
    if (!outcome_type) {
      outcome_type = 'quarterly';
    }
    this.kanbanPayload.outcome_type = outcome_type;

    if (this.selQuater && this.selQuater.trim() !== '') {
      if (this.kanbanPayload.outcome_type == 'quarterly') {
        this.kanbanPayload.outcome_quarters = this.selQuater;
      } else {
        this.kanbanPayload.outcome_quarters = '';
      }
    }
    this.kanbanPayload.outcome_year=this.outcome_year
    this.kanbanPayload.outcome_groups=this.selGroups || ''

    this.kanbanPayload.member_id=this.selectMember || ''

    const payload = {
      ...this.kanbanPayload,
      outcome_status,
     
    };
    this.isKanbanBoardDataLoaded = true;
    this.kanbanService.getKanbanList(payload, cat).subscribe(
      (data: any) => {
        try {
          const parsedData = data;
          if (outcome_status == '1') {
            this.notStartedCount = parsedData?.count;
            this.notstarted = parsedData.data || [];
          } else if (outcome_status == '2') {
            this.ongoingCount = parsedData?.count;
            this.ongoing = parsedData.data || [];
          } else if (outcome_status == '3') {
            this.completedCount = parsedData?.count;
            this.completed = parsedData.data || [];
          } else if (outcome_status == '4') {
            this.delayedCount = parsedData?.count;
            this.delayed = parsedData.data || [];
          } else if (outcome_status == '5') {
            this.terminatedCount = parsedData?.count;
            this.terminated = parsedData.data || [];
            this.isKanbanBoardDataLoaded = false;
          }
          this.kanbanCardData = parsedData.data || [];
        } catch (error) {
          console.error('Error parsing decoded data:', error);
        }
      },
      (error) => {
        console.error('Error fetching users', error);
      }
    );
  }

  onValueChange(outcome_type: any): void {
    this.kanbanCardData = [];
    this.kanbanPayload.outcome_type = outcome_type;
    this.getAllKanbanList();
  }

  onQuarterFilterChange(data: any) {
    this.kanbanCardData = [];
    this.selQuater = data;
    this.kanbanPayload.outcome_quarters = data;
    this.getAllKanbanList();
  }

  getAllKanbanList() {
    this.kanbanList(this.category, this.value, '1');
    this.kanbanList(this.category, this.value, '2');
    this.kanbanList(this.category, this.value, '3');
    this.kanbanList(this.category, this.value, '4');
    this.kanbanList(this.category, this.value, '5');
  }

  quarterFields(timelines: any[]) {
    timelines.forEach((timeline) => {
      timeline.quarterVal = `Cycle ${timeline.quarter}`;
    });
  }

  getGroupList(search: string = '',isSearch:any=false, isInit: any = false): void {
    const data = {
      search: search,
      member_id: this.helper.loggedInUser?.user_id,
    };
    this.wizardService.groupList(data,this.category).subscribe(
      (data: any) => {
        try {
          const parsedData = data;
          const group = parsedData.data || [];
          this.groupFilter = group.map((item: any) => ({
            label: item.name,
            value: item.group_id,
          }));

          if(!isSearch){
            this.getAllKanbanList();
          }
          else {
            if (!this.selGroups) {
              this.selGroups = this.groupFilter[0]?.value;
              this.selectedGroup = this.groupFilter[0];
            }
            if (this.groupFilter.filter((x: any) => x.value == this.selGroups).length == 0) {
              this.groupFilter.unshift(this.selectedGroup);
            }
            this.getGroupMembers(this.selGroups);
            if (isInit) {
              this.getAllKanbanList();
            }
          }
        } catch (error) {
          console.log('Error parsing decoded data:');
        }
      },
      (error) => {
        console.log('Error fetching users');
      }
    );
  }

  onGroupChange(event: any) {
    this.selectedGroup = this.groupFilter.filter((x: any) => x.value == this.selGroups)[0];
    this.selGroups = event.value?.value || event?.value || '';  
    this.selectMember = null;
    this.getGroupMembers(event.value?.value || event?.value);
    this.getAllKanbanList();
  }

  onSelectMember(event: any) {
    this.selectMember = event.value || '';
    this.getAllKanbanList();
  }

 async getGroupMembers(val: any) {
    const data = {
      groups: val,
      search: '',
    };
    this.wizardService.groupMembers(data).subscribe(
      (data: any) => {
        try {
          const parsedData = data;
          this.members = parsedData.data || [];
        } catch (error) {
          console.log('Error parsing decoded data');
        }
      },
      (error) => {
        console.log('Error fetching users');
      }
    );
  }

  onGroupSearch(event: any) {
    this.getGroupList(event?.filter,true);
  }

  ngOnDestroy() {
    if (this.ref) {
      this.ref.close();
    }
    if (this.roleSubscription) {
      this.roleSubscription.unsubscribe(); 
    }

    if (this.quaterSubscription) {
      this.quaterSubscription.unsubscribe();
    }

    this.sidebarService.selectedKanbanDashboardYear = null;
  }
}
